import { render } from "./TicketChatLogs.vue?vue&type=template&id=5b1bef39&scoped=true"
import script from "./TicketChatLogs.vue?vue&type=script&lang=js"
export * from "./TicketChatLogs.vue?vue&type=script&lang=js"

import "./TicketChatLogs.vue?vue&type=style&index=0&id=5b1bef39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1bef39"]])

export default __exports__